import React, { useState } from 'react'
import '../App.css'
import Bounce from 'react-reveal/Bounce'
import ReactDOM from 'react-dom';
import Register from '../Register'


function Exit(){
    localStorage.setItem('name', '');
    localStorage.setItem('email', '');
    let state = {name: '', email: ''}
    ReactDOM.render(
      <Info state = {state}/>,
    document.getElementById('Info'));
}

function User(props) {
    return <div class="borderMain border4"><h1>Hello, {props.state.name}</h1><br /> 
    Your email: {props.state.email}<br />
    <button class="inputJoin" onClick={Exit}>Exit</button>
    </div>;
  }
  
function Info(props){
    if( props.state.email === '' ||  props.state.name === ''){
        return <div class="borderJoin Register"><Register /></div>
    }
    else{
          return <User state = {props.state}/>
    }
}

class Account extends React.Component { 
    constructor(props) {
    super(props);
    this.state = {email: '', name: ''};
    this.state.name = localStorage.getItem('name');
    this.state.email = localStorage.getItem('email');
  }

    render() {
    return (
    <div className="App">
    <header className="App-header">
      <a align="center" href="/SiteReact/"><Bounce>WorkSpace</Bounce></a>
    </header>
    <div id="Info"><Info state = {this.state}/></div>
    <footer>
   <div class="App-header footAbout">Copyright Asquardian</div></footer>

    </div>);
    }
}

export default Account;